export const getJobOfferKindIsAgent = (kind?: string | null): boolean => {
  if (!kind) return false;
  return kind === '0';
};

export const getJobOfferKindIsDirect = (kind?: string | null): boolean => {
  if (!kind) return false;
  return kind === '2';
};

export const getJobOfferKindIsWithoutApplyButton = (
  kind?: string | null
): boolean => {
  if (!kind) return false;
  return kind === '4';
};
